module.exports = __webpack_public_path__ + "static/scale-model-of-hialeah-florida-79ac9d0e67cec902032d4247d40a7e0b.png";